<template>
  <CRow>
    <CCol col="12" md="7">
      <CCard>
        <CCardHeader>
          <div>
            <p>
              <img src="img/location.svg" style="width:20px" />
              Route
            </p>
          </div>
        </CCardHeader>
        <br>
<div class="row">
  <!-- <div clsass="col-sm-4">   <h5> Sepices</h5></div> -->
  <div class="col-sm-6" >
   &nbsp;&nbsp;&nbsp; <Vselect :options="routeItemlist" v-model="routeName1"   searchable  style="margin-left:10px"/>  
  </div>
  <div class="col-sm-2">
    <CButton color="info" @click="go">
            GO
              </CButton>
  </div>

</div>
       <CCardBody>
          <CDataTable
          :items="routeItem1"
          :fields="fields"
          table-filter
          items-per-page-select
          :items-per-page="5"
          sorter
          pagination
          clickable-rows
          hover
          @row-clicked="rowClicked"
          caption="Breed"
        />
       </CCardBody>
      </CCard>
    </CCol>
    <CCol col="6" md="5">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/location.svg" style="width:20px" /> Route Details
          </p>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CInput
              label="Route Code"
              horizontal
              autocomplete="name"
              name="routeCode"
              id="routeCode"
              required
              v-model="routeCode"
            />

            <CInput
              label="Route Name"
              horizontal
              autocomplete="name"
              name="routeName"
              id="routeName"
              required
              v-model="routeName"
            />
            <CInput
              label="Contact Person"
              horizontal
              autocomplete="name"
              name="contactPerson"
              id="contactPerson"
              required
              v-model="contactPerson"
            />
            <CInput label="Email" horizontal autocomplete="name" v-model="email" />
            <CInput
              label="Mobile No"
              horizontal
              autocomplete="name"
              name="mobileNumber"
              id="mobileNumber"
              required
              v-model="mobileNumber"
            />

            <CRow>
              <CCol sm="3">
                <h5 style="font-size:15px">Active</h5>
              </CCol>
              <CCol sm="3">
                
                <CSwitch
                  class="mx-1"
                  color="primary"
                  checked
                  variant="opposite"
                  style="width:50px;float:left !important"
                  shape="pill"
                  v-bind="labelTxt"
                  name="suspend"
                  id="suspend"
                  required
                  v-model="suspend"
                />
                <!-- <input
  type="checkbox"
  v-model="suspend"
  true-value="yes"
  false-value="no"
> -->
              </CCol>
            </CRow>
          </CForm>
        </CCardBody>
        <CCardFooter>
          <CButton color="info" style="width:100px" v-if="addButton" @click="addRoute">
            <CIcon name="cilPencil" />&nbsp;Add
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="saveButton" @click="updateRoute">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;
          <CButton color="danger" style="width:100px" v-if="deleteButton" @click="deleteRoute">
            <CIcon name="cilXCircle" />&nbsp;Delete
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="EditsaveButton" @click="addRoute">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;
          <CButton color="secondary" style="width:100px" v-if="cancelButton" @click="CancelRoute">
            <CIcon name="cilWarning" />&nbsp;Cancel
          </CButton>&nbsp;
          <CButton color="info" v-if="addnewButton" @click="addRouteplus">
            <CIcon name="cilPencil" />&nbsp;Add New
          </CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../../tables/Table";
import { APIService } from "../../../apiservice.js";
import Swal from "sweetalert2";
import { Vselect } from "@/components";
export default {
  components: { CTableWrapper,Vselect },

  data() {
    return {
      routeItemlist:[],
      routeName1:null,
      routeItem: [],
       routeItem1: [],
      editroute: [],
      routeCode: null,
      routeName: "",
      contactPerson: "",
      email: "",
      mobileNumber: "",
      suspend: true,
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,
      labelTxt: {
        labelOn: "yes",
        labelOff: "no"
      },
      fields: [
        {
          key: "routeCode",
          sortable: true
        },
        {
          key: "routeName",
          sortable: true
        },
        {
          key: "contactPerson",
          sortable: true
        },
        {
          key: "mobileNumber",
          sortable: true
        },
        {
          key: "suspend",
          sortable: true
        }
      ],
   
    };
  },
  methods: {

       go(){
  this.routeItem1 = this.routeItem.filter( n=>
 n.routeName == this.routeName1 )
  },
     getRouteList() {
      APIService.routeList().then(res => {
        if (res.status == 200) {
          this.routeItem = res.data;
 this.routeItem1 = res.data;

      this.routeCode = this.routeItem[0].routeCode;
      this.routeName = this.routeItem[0].routeName;
      this.contactPerson = this.routeItem[0].contactPerson;
      this.email = this.routeItem[0].email;
      this.mobileNumber = this.routeItem[0].mobileNumber;
      this.suspend = this.routeItem[0].suspend;
          // console.log("check",routeItem.suspend)

          let value = this.routeItem.map(n=>{
            return n.routeName
          })

          // this.routeItemlist= value;

         let uniquechar = value.filter((c,index)=>{
           return value.indexOf(c) === index;
         }) 
 this.routeItemlist= uniquechar;

          console.log("routename",value)
        }
      });
    },

    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.editroute = item;
      this.routeCode = item.routeCode;
      this.routeName = item.routeName;
      this.contactPerson = item.contactPerson;
      this.email = item.email;
      this.mobileNumber = item.mobileNumber;
      this.suspend = item.suspend;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false;
    },
    addRoute() {
      let routeCode = this.routeCode;
      let routeName = this.routeName;
      let contactPerson = this.contactPerson;
      let email = this.email;
      let mobileNumber = this.mobileNumber;
      let suspend = this.suspend;
      let data = {
        routeCode,
        routeName,
        contactPerson,
        email,
        mobileNumber,
        suspend
      };
      APIService.saveRoute(data).then(res => {
        if (res.status == 200) {
          this.routeCode = null;
          this.routeName = "";
          this.contactPerson = "";
          this.email = "";
          this.mobileNumber = "";
          this.suspend = "";
          this.getRouteList();
           Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    addRouteplus() {
      this.routeCode = null;
      this.routeName = "";
      this.contactPerson = "";
      this.email = "";
      this.mobileNumber = "";
      this.suspend = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = true;
      this.addnewButton = false;
      (this.EditsaveButton = true) 
       return getRouteList();
    },

    CancelRoute() {
      this.routeCode = null;
      this.routeName = "";
      this.contactPerson = "";
      this.email = "";
      this.mobileNumber = "";
      this.suspend = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = false;
      this.addnewButton = true;
      (this.EditsaveButton = false),  this.getRouteList();
    },
    updateRoute() {
       let id = this.editroute._id;
     let routeCode = this.routeCode;
      let routeName = this.routeName;
      let contactPerson = this.contactPerson;
      let email = this.email;
      let mobileNumber = this.mobileNumber;
      let suspend = this.suspend;
      let value = {
        routeCode,
        routeName,
        contactPerson,
        email,
        mobileNumber,
        suspend
      };
      let data = { id, value };
      APIService.routeUpdate(data).then(res => {
        if (res.status == 200) {
          this.routeCode = null;
          this.routeName = "";
          this.contactPerson = "";
          this.email = "";
          this.mobileNumber = "";
          this.suspend = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
         this.getRouteList();
          Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    deleteRoute() {
      const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger'
  },
  buttonsStyling: false
})

swalWithBootstrapButtons.fire({
  title: 'Are you sure?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, delete it!',
  cancelButtonText: 'No, cancel!',
  reverseButtons: true
}).then((result) => {
  if (result.value) {
    swalWithBootstrapButtons.fire(
      'Deleted!',
      'Your file has been deleted.',
      'success'
    )
     this.delete();
  } else if (
    /* Read more about handling dismissals below */
    result.dismiss === Swal.DismissReason.cancel
  ) {
    swalWithBootstrapButtons.fire(
      'Cancelled',
      'Your imaginary file is safe :)',
      'error'
    )
  }
})

    },
    delete(){
      let id = this.editroute._id;
      let data = { id };
      APIService.routeDelete(data).then(res => {
        if (res.status == 200) {
          this.routeCode = null;
          this.routeName = "";
          this.contactPerson = "";
          this.email = "";
          this.mobileNumber = "";
          this.suspend = "";
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          (this.EditsaveButton = false),  this.getRouteList();
        }
      });
    }
  },
  created() {
    this.getRouteList();
  }
};
</script>
